import { useState } from "react";
import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 12px 15px;
  border: 1px solid ${colors.dash};
  border-radius: 6px;
  font-size: 15px;
  transition: border 0.2s, box-shadow 0.2s;

  &:focus {
    outline: none;
    border-color: #666;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
  }
`;

const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 6px 6px;
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
`;

const DropdownItem = styled.li`
  padding: 10px 15px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
  }
`;

const InputfieldWithDropDown = ({
  type,
  value,
  onChange,
  options,
  placeholder,
  ...props
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);

    if (type === "dropdown") {
      setIsDropdownOpen(true);
      onChange(newValue);
    } else {
      onChange(e);
    }
  };

  const handleOptionSelect = (option) => {
    setInputValue(option);
    onChange(option);
    setIsDropdownOpen(false);
  };

  const handleBlur = () => {
    setTimeout(() => setIsDropdownOpen(false), 200);
  };

  if (type === "dropdown") {
    const filteredOptions = options.filter((option) =>
      option.toLowerCase().includes(inputValue.toLowerCase())
    );

    return (
      <InputContainer>
        <StyledInput
          type="text"
          value={value}
          onChange={handleInputChange}
          onFocus={() => setIsDropdownOpen(true)}
          onBlur={handleBlur}
          placeholder={placeholder}
          {...props}
        />
        {isDropdownOpen && filteredOptions.length > 0 && (
          <DropdownList>
            {filteredOptions.map((option) => (
              <DropdownItem
                key={option}
                onMouseDown={() => handleOptionSelect(option)}
              >
                {option}
              </DropdownItem>
            ))}
          </DropdownList>
        )}
      </InputContainer>
    );
  }

  return (
    <StyledInput
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default InputfieldWithDropDown;
